/**
 * Stack - Smooth Scroll
 * Intercepta clicks en enlaces ancla (#) y hace scroll animado.
 * Tiene en cuenta el sticky header para calcular el offset.
 */
(function () {
  function getHeaderOffset() {
    var header = document.querySelector('.shopify-section-header, .section-header, header');
    if (header && getComputedStyle(header).position === 'sticky' || 
        header && getComputedStyle(header).position === 'fixed') {
      return header.offsetHeight + 16;
    }
    return 16;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;

    var hash = link.getAttribute('href');
    if (!hash || hash === '#') return;

    var target = document.querySelector(hash);
    if (!target) return;

    e.preventDefault();

    var offset = getHeaderOffset();
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });

    // Update URL hash without jumping
    if (history.pushState) {
      history.pushState(null, null, hash);
    }
  });
})();
